<h2 class="form-h2">Change Password</h2>
<form [formGroup]="form" autocomplete="off" style="margin-top: 8px">
  <div class="form-fields">
    <!-- Current Password Field -->
    <mat-form-field appearance="outline">
      <mat-label>Current Password</mat-label>
      <input matInput type="password" formControlName="currentPassword" placeholder="Current Password" required data-lpignore="true" autocomplete="off" />
      @if (currentPassword.hasError("required")) {
        <mat-error> Current Password Required </mat-error>
      }
    </mat-form-field>

    <!-- New Password Field -->
    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" placeholder="New Password" required data-lpignore="true" autocomplete="off" />
      @if (newPassword.hasError("required")) {
        <mat-error> New Password Required </mat-error>
      } @else if (newPassword.hasError("strongPassword")) {
        <mat-error> New Password must be at least 8 characters long and include a letter, a number, and a special character. </mat-error>
      }
    </mat-form-field>
    <!-- Confirm Password Field -->
    <mat-form-field appearance="outline">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" placeholder="Confirm Password" required data-lpignore="true" autocomplete="off" />
      @if (confirmPassword.hasError("required")) {
        <mat-error> Confirm Password Required </mat-error>
      } @else if (confirmPassword.hasError("strongPassword")) {
        <mat-error> Confirm Password must be at least 8 characters long and include a letter, a number, and a special character. </mat-error>
      }
      <!--  -->
    </mat-form-field>
    @if (form.hasError("passwordsMismatch") && confirmPassword.touched) {
      <mat-error> Passwords do not match </mat-error>
    }
  </div>
</form>

<div class="alert-info">Info: Password change applies immediately.</div>

@if (apiErrorMessage()) {
  <div class="alert-danger" style="margin-top: 24px">
    Edit User Error
    {{ apiErrorMessage() }}
  </div>
}

<div class="form-action-btn">
  <button mat-raised-button (click)="routeBack()">Cancel</button>
  <button mat-flat-button cdkFocusInitial [disabled]="form.invalid || saveState()" (click)="onSubmit()">Update</button>
</div>
